import { AsyncHorizontalOverviewNav } from '@atlassian/jira-business-horizontal-nav/src/async.tsx';
import { globalLayout } from '@atlassian/jira-global-layout/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarCore from '@atlassian/jira-navigation-apps-sidebar-core/src/async.tsx';
import { ThemedLazySkeleton } from '@atlassian/jira-project-theme-components/src/ui/ThemedLazySkeleton.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getOverviewViewResources } from '@atlassian/jira-router-resources-business-common/src/index.tsx';
import { classicBusinessOverviewTimelineRoute } from '@atlassian/jira-router-routes-business-routes/src/classicBusinessOverviewTimelineRoute.tsx';
import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { overviewTimelineEntrypoint } from '@atlassian/jira-spa-apps-business-overview-timeline/entrypoint.tsx';

const overviewTimelinePageEntrypoint = createPageEntryPoint({
	main: overviewTimelineEntrypoint,
	topNavigationMenuId: MENU_ID.PROJECTS,
});

export const classicBusinessOverviewTimelineRouteEntry = createEntry(
	classicBusinessOverviewTimelineRoute,
	() => ({
		group: 'classic-business',
		layout: globalLayout,
		skeleton: ThemedLazySkeleton,

		navigation: {
			menuId: MENU_ID.PROJECTS,
			sidebar: AsyncSidebarCore,
			horizontal: AsyncHorizontalOverviewNav,
		},

		resources: getOverviewViewResources(),

		entryPoint: () => overviewTimelinePageEntrypoint,
	}),
);
